import * as React from 'react'

import type { Form } from 'factorial-form'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { locationTypeOptions } from 'modules/attendance/lib/locationType'
import AttendanceShiftUtils from 'modules/attendance/lib/utils/AttendanceShift'

interface Props {
  form: Form
  shifts: TimesheetPageShiftFragment[]
}

const ShiftLocationForm = ({ form, shifts }: Props) => {
  const id = Number(form.get('id').value)
  const shift = shifts.find((shiftValue) => shiftValue.id === id)
  const clockInStr = shift ? AttendanceShiftUtils.clockInTimeStr(shift) : ''
  const clockOutStr = shift ? AttendanceShiftUtils.clockOutTimeStr(shift) : ''
  let label = `${i18n.t('clock_in.locations.modal.field_title')} ${clockInStr}`

  if (shift?.clockOut) {
    label = `${label} - ${clockOutStr}`
  }

  return (
    <Select
      none={i18n.t('clock_in.locations.modal.field_placeholder')}
      label={label}
      value={form.get('locationType').value}
      options={locationTypeOptions()}
      onChange={(value) => form.setValues({ locationType: value })}
    />
  )
}

export default observer(ShiftLocationForm)
